import axios from "axios";

export const fetchCustomer = async (userID, setStateCallbacks) => {
    const { setLoading, setCustomers, setFreelancers, setUserDetails } = setStateCallbacks;

    try {
        setLoading(true);
        const { data } = await axios.get(`/admin/user/user/${userID}`);
        const { customers, freelancers, user } = data.response;

        setCustomers(customers);
        setFreelancers(freelancers);
        setUserDetails(user);
        return user;
    } catch (err) {
        setCustomers([]);
        setFreelancers([]);
        console.error("Error fetching customers:", err);
        return null;
    } finally {
        setLoading(false);
    }
};
